import { Schema } from '@effect/schema';
export const PrologRuleId = Schema.String.pipe(Schema.brand('PrologRuleId'));
/**
 * A Prolog rule associated with a Template via the ID.
 */
export const PrologRule = Schema.Struct({
    id: PrologRuleId,
    name: Schema.String,
    rule: Schema.String,
});
